import React from "react"

import sendScrollPercentEvent from '../../actions/events/sendScrollPercentEvent'
import sendReadingEvent from '../../actions/events/sendReadingEvent'

class ScrollPercentageTracking extends React.Component {

  componentDidMount() {
    this._lastPercent = 0
    this.startRead = 0

    this._timer = setInterval(this.handleSendScrollEvent, 1000)

    sendReadingEvent({
      url: this.props.location.pathname,
      action: 'Page Loaded'
    })
  }

  componentWillUnmout() {
    clearInterval(this._timer)
  }

  handleSendScrollEvent = () => {
    const h = document.documentElement
    const b = document.body
    const st = 'scrollTop'
    const sh = 'scrollHeight'
    let percent = (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100

    if (percent >= 95) {
      percent = 100
    } else if (percent >= 75) {
      percent = 75
    } else if (percent >= 50) {
      percent = 50
    } else if (percent >= 25) {
      percent = 25
    } else {
      percent = 0
    }

    if (percent <= this._lastPercent) {
      return
    }

    this._lastPercent = percent
    sendScrollPercentEvent({
      url: this.props.location.pathname,
      percent: percent
    })

    if (percent === 25) {
      sendReadingEvent({
        url: this.props.location.pathname,
        action: 'Reading Start'
      })
      this.startRead = new Date().getTime()
    }

    if (percent === 75) {
      const timeToEnd = Math.round((new Date().getTime() - this.startRead) / 1000);
      if (timeToEnd < 60) {
        sendReadingEvent({
          url: this.props.location.pathname,
          action: 'Scanning End'
        })
      } else {
        sendReadingEvent({
          url: this.props.location.pathname,
          action: 'Reading End'
        })
      }
    }
  }

  render() {
    return <div>{ this.props.children }</div>
  }

}
export default ScrollPercentageTracking



// WEBPACK FOOTER //
// ./src/components/Tracking/ScrollPercentageTracking.js